import React, { useEffect, useState } from 'react';
import warehouse_1 from '../Assets/imgs/warehouse_1.jpg';
import warehouse_2 from '../Assets/imgs/warehouse_2.jpg';
import warehouse_3 from '../Assets/imgs/warehouse_3.jpg';

const carouselImages = [
  { id: 1, image: warehouse_1 },
  { id: 2, image: warehouse_2 },
  { id: 3, image: warehouse_3 },
];

export default function Carousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative text-center min-h-screen overflow-hidden">
      {carouselImages.map(({ id, image }, index) => (
        <img
          key={id}
          src={image}
          alt={`Background ${id}`}
          className={`
            absolute inset-0 w-full h-full object-cover transition-opacity duration-1000
            ${index === currentIndex ? 'opacity-70' : 'opacity-0'}
            select-none pointer-events-none
          `}
          loading="lazy"
        />
      ))}

      {/* Overlay for text readability */}
      <div className="absolute inset-0 bg-blue-100 bg-opacity-10"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 py-20 sm:py-32 flex flex-col justify-center min-h-screen">
        <h2 className="text-3xl sm:text-5xl font-bold mb-4 text-gray-900">
          Powering Mobile Distribution
        </h2>
        <p className="text-base sm:text-lg text-gray-700 mb-6 max-w-xl mx-auto ">
          Delivering the latest smartphones to retailers across the region.
        </p>
        {/* <button className="bg-[#00AEEA]  text-white px-6 py-3 rounded-full hover:bg-blue-700 transition mx-auto">
          Get Started
        </button> */}
      </div>
    </section>
  );
}

// import React, { useEffect, useState } from 'react';
// import warehouse_1 from '../Assets/imgs/warehouse_1.jpg';
// import warehouse_2 from '../Assets/imgs/warehouse_2.jpg';
// import warehouse_3 from '../Assets/imgs/warehouse_3.jpg';

// const carouselImages = [
//   { id: 1, image: warehouse_1 },
//   { id: 2, image: warehouse_2 },
//   { id: 3, image: warehouse_3 },
// ];

// export default function Carousel() {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex(prev => (prev + 1) % carouselImages.length);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <section className="relative text-center py-12 sm:py-16 overflow-hidden">
//       {carouselImages.map(({ id, image }, index) => (
//         <img
//           key={id}
//           src={image}
//           alt={`Background ${id}`}
//           className={`
//             absolute inset-0 w-full h-full object-cover transition-opacity duration-1000
//             ${index === currentIndex ? 'opacity-70' : 'opacity-0'}
//             select-none pointer-events-none
//             max-h-[60vh] sm:max-h-full
//           `}
//           loading="lazy"
//         />
//       ))}

//       <div className="absolute inset-0 bg-blue-100 bg-opacity-60"></div>

//       <div className="relative z-10 max-w-4xl mx-auto px-4">
//         <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-gray-900">
//           Powering Mobile Distribution
//         </h2>
//         <p className="text-base sm:text-lg text-gray-700 mb-6">
//           Delivering the latest smartphones to retailers across the region.
//         </p>
//         <button className="bg-blue-600 text-white px-5 py-2 sm:px-6 sm:py-3 rounded-full hover:bg-blue-700 transition">
//           Get Started
//         </button>
//       </div>
//     </section>
//   );
// }


// // import React, { useEffect, useState } from 'react';

// // const carouselImages = [
// //   '../Assets/imgs/warehouse_1.jpg',
// //   '../Assets/imgs/warehouse_2.jpg',
// //   '../Assets/imgs/warehouse_3.jpg',
// // ];

// // export default function Carousel() {
// //   const [currentIndex, setCurrentIndex] = useState(0);

// //   // Change image every 5 seconds
// //   useEffect(() => {
// //     const interval = setInterval(() => {
// //       setCurrentIndex(prev => (prev + 1) % carouselImages.length);
// //     }, 5000);
// //     return () => clearInterval(interval);
// //   }, []);

// //   return (
// //     <section className="relative text-center py-16 overflow-hidden">
// //       {/* Carousel Background Images */}
// //       {carouselImages.map((src, index) => (
// //         <img
// //           key={index}
// //           src={src}
// //           alt={`Background ${index + 1}`}
// //           className={`
// //             absolute inset-0 w-full h-full object-cover transition-opacity duration-1000
// //             ${index === currentIndex ? 'opacity-70' : 'opacity-0'}
// //             select-none pointer-events-none
// //           `}
// //           loading="lazy"
// //         />
// //       ))}

// //       {/* Overlay to keep text readable */}
// //       <div className="absolute inset-0 bg-blue-100 bg-opacity-60"></div>

// //       {/* Content */}
// //       <div className="relative z-10 max-w-4xl mx-auto px-4">
// //         <h2 className="text-4xl font-bold mb-4 text-gray-900">Powering Mobile Distribution</h2>
// //         <p className="text-lg text-gray-700 mb-6">Delivering the latest smartphones to retailers across the region.</p>
// //         <button className="bg-blue-600 text-white px-6 py-3 rounded-full hover:bg-blue-700 transition">
// //           Get Started
// //         </button>
// //       </div>
// //     </section>
// //   );
// // }
